<template>
  <div
    v-if="!cookiesConsent"
    class="fixed right-0 bottom-0 p-6 slide-in-bottom"
  >
    <div class="alert shadow-lg max-w-sm">
      <div class="flex-col items-start">
        <h1 class="font-bold">Cookies</h1>

        <div class="text-sm pb-2">
          We use cookies to ensure you get best experience on our website.
          <a href="/cookies/" class="link"> Learn more </a>
        </div>

        <form action="/set-cookie/" method="post" class="w-full">
          <input name="csrfmiddlewaretoken" type="hidden" :value="csrfToken" />
          <input type="hidden" name="key" value="cookies_consent" />
          <button type="submit" class="btn btn-primary w-full">Got it!</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { VueCookies } from "vue-cookies";

const $cookies = inject<VueCookies>("$cookies") as VueCookies;
const csrfToken = $cookies.get("csrftoken");
const cookiesConsent = $cookies.get("cookies_consent");

// If user has never been to the main website they need to go there first to get the token cookie
if (csrfToken == null) {
  // FIXME: redirect back "/?next=/inscribe"
  window.location.replace("/");
}
</script>
